import { watch } from 'vue';
/** Watches a boolean source and invokes the callback whenever it becomes truthy. */
export function onTrigger(trigger, callback) {
    watch(trigger, value => {
        if (value) {
            callback();
        }
    });
}
//# sourceMappingURL=onTrigger.js.map